import { useContext } from 'react';

import { QuestionCreationTaskDetailsModalContext } from './question-creation-task-details-modal-provider';

export function useQuestionCreationTaskDetailsModal() {
  const context = useContext(QuestionCreationTaskDetailsModalContext);

  if (!context) {
    throw new Error(
      'useQuestionCreationTaskDetailsModal must be used within a QuestionCreationTaskDetailsModalProvider',
    );
  }

  return context;
}
